import { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  Badge,
  IconButton,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import { Menu, Notifications} from "@mui/icons-material";
import { UserAPI } from "../apis/userApi";

import useAsyncEffect from "use-async-effect";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../redux/userSlice";
import MainMenu from "./MainMenu";
import { TasksAPI } from "../apis/tasksApi";
import { setTasks } from "../redux/taskSlice";
import { EventsAPI } from "../apis/eventsAPI";
import { setEvents } from "../redux/eventSlice";
import NotificationsDrawer from "./NotificationsDrawer";
import constants from "../static/constants.json";
import { RequestsAPI } from "../apis/requestsAPI";
import { setRequests } from "../redux/requestSlice";
import JoinNowButton from "./common/JoinNowButton";
const NavBar = () => {
  const dispatch = useDispatch();
  const isProduction = process.env.REACT_APP_NODE_ENV === "production";
  const user = useSelector((state: any) => state.user);
  const events = useSelector((state: any) => state.events.list);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [numUnseenEvents, setNumUnseenEvents] = useState(0);

  useAsyncEffect(async () => {
    try {
      const u = await UserAPI.get();
      dispatch(setUser(u));
    } catch (e) {
      // TODO here we could direct them to sign in page
      navigate("/");
      dispatch(setUser({}));
    }
  }, []);

  useAsyncEffect(async () => {
    // if (user && user.id) {
    try {
      const ts = await TasksAPI.getTasks();
      dispatch(setTasks(ts));
    } catch (e) {
      // TODO here we could direct them to sign in page
      console.log("error getting tasks,", e);
    }
  }, [user.id]);

  // useAsyncEffect(async () => {
  //   if (user && user.id) {
  //     try {
  //       const ts = await JobsAPI.listJobs();
  //       dispatch(setJobs(ts));
  //     } catch (e) {
  //       // TODO here we could direct them to sign in page
  //       console.log("error getting jobs,", e);
  //     }
  //   }
  // }, [user.id]);

  useAsyncEffect(async () => {
    if (user.id) {
      try {
        const es = await EventsAPI.getEvents();
        dispatch(setEvents(es));

        const js = await RequestsAPI.getRequests();
        dispatch(setRequests(js || []));
      } catch (e) {
        // TODO here we could direct them to sign in page
        console.log("error getting events or requests,", e);
      }
    }
  }, [user.id]);

  useEffect(() => {
    if (user && user.id) {
      const unseen = events.filter((e: any) => {
        return (
          e.actorId !== user.id &&
          !e.seen &&
          e.typeId !== constants.eventType.created
        );
      });
      setNumUnseenEvents(unseen.length);
    }
  }, [events, user]);

  const navigate = useNavigate();

  const rightSideContent =
    user && user.id ? (
      <>
        <IconButton
          onClick={() => {
            setIsNotificationsOpen(true);
          }}
        >
          <Badge badgeContent={numUnseenEvents} color="error">
            <Notifications />
          </Badge>
        </IconButton>

        <IconButton onClick={() => setIsMenuOpen(true)}>
          <Menu />
        </IconButton>
      </>
    ) : (
      <>
      {isProduction ? (null) : (
        <Button
        className="secondaryButton"
        style={{
          width: "10rem",
          borderRadius: "1.25rem",
          fontFamily: "Arial",
        }}
        disabled={isProduction}
        onClick={() => {
          navigate("/sign-in");
        }}
      >
        Log in
      </Button>
      )}
        
        <JoinNowButton />
      </>
    );
  return (
    <Box sx={{ flexGrow: 1 }}>
      <MainMenu open={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      <NotificationsDrawer
        open={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
      />
      <AppBar
        position="static"
        style={{ padding: "24px", background: "white", position: "absolute" }}
      >
        <Toolbar style={{ background: "white" }}>
          <Box sx={{display: 'flex', alignItems: 'center', 'border': '1px none black'}}>
            <Typography
              onClick={() => navigate("/")}
              color="black"
              style={{
                cursor: "pointer",
              }}
            >
              Nabor Labor{" "}
              
            </Typography>
            {/* <SentimentSatisfiedAlt fontSize="large" color="primary"/> */}
          </Box>

          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <Menu />
          </IconButton> */}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          ></Typography>
          {rightSideContent}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default NavBar;
